import React from 'react';

interface CarParameterItem {
  label: string;
  value: string | null;
}

interface CarParametersProps {
  parameters: CarParameterItem[];
}

export const CarParameters: React.FC<CarParametersProps> = ({ parameters }) => {
  const visibleParams = parameters.filter((p) => p.value);

  if (visibleParams.length === 0) return null;

  return (
    <div className="flex flex-col flex-wrap mb-4 w-full bg-white rounded-2xl border border-solid j ustify-between md:flex-row border-zinc-200 max-md:max-w-full">
      {visibleParams.map((param) => (
        <React.Fragment key={param.label}>
          <div className="flex flex-1 flex-col justify-center border-b md:border-l md:border-b-0 border-zinc-200 px-[20px] py-[18px] md:first-of-type:border-0 last-of-type:border-0 md:last-of-type:border-l">
            <div className="mb-[8px] text-sm leading-none text-gray-500">
              {param.label}
            </div>
            <div className="self-start text-sm font-semibold leading-none text-zinc-800">
              {param.value}
            </div>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};
